import { css } from 'styled-system/css';
import type { AGENTS } from './agents';
import { ExplodePins } from './ExplodePins';
import { IsoFace } from './IsoFace';
import { iso } from './isometric';

const WINDOW_ELEVATION = 96;
const WINDOW_WIDTH = 108;
const WINDOW_DEPTH = 72;
const LOGO_LIFT = 80;
const LOGO_SIZE = 32;
const WINDOW_RADIUS = 4;

export function AgentLayer({ agent }: { agent: (typeof AGENTS)[number] }) {
  const { x, y, name, lines, color, logo } = agent;
  const midX = x + WINDOW_WIDTH / 2;
  const midY = y + WINDOW_DEPTH / 2;
  const mark = iso(midX, midY, WINDOW_ELEVATION + LOGO_LIFT);
  return (
    <g>
      <ExplodePins
        x={x}
        y={y}
        z0={0}
        z1={WINDOW_ELEVATION}
        w={WINDOW_WIDTH}
        depth={WINDOW_DEPTH}
      />
      <IsoFace x={x} y={y} z={WINDOW_ELEVATION}>
        <rect
          width={WINDOW_WIDTH}
          height={WINDOW_DEPTH}
          rx={WINDOW_RADIUS}
          ry={WINDOW_RADIUS}
          className={css({ stroke: color })}
        />
        <line x1={6} y1={18} x2={WINDOW_WIDTH - 6} y2={18} />
        <text
          x={6}
          y={13}
          className={css({
            fill: 'text.primary',
            stroke: 'none',
            fontSize: '11px',
          })}
        >
          {name}
        </text>
        {lines.map((line, i) => (
          <text
            key={line}
            x={8}
            y={32 + i * 12}
            className={css({
              fill: 'text.secondary',
              stroke: 'none',
              fontSize: '8px',
            })}
          >
            {line}
          </text>
        ))}
      </IsoFace>
      <image
        href={logo}
        x={mark.x - LOGO_SIZE / 2}
        y={mark.y - LOGO_SIZE / 2}
        width={LOGO_SIZE}
        height={LOGO_SIZE}
      />
    </g>
  );
}
